/**
 * Created by scottrohrer on 6/29/16.
 */

// Contains all terms to be translated.
// English words in all caps will be replaced with numerical values.
// These words should be not translated, but should be positioned correctly within the translation.
// IT: Translated by - Dr Caterina Benzi and Raffaele Borrelli, Università di Torino

define(function() {
    return {
        languageList: [
            {
                name: "English",
                code: "en"
            },
            {
                name: "Español",
                code: "es"
            },
            {
                name: "Italiano",
                code: "it"
            }
        ],
        nav: {
            file: {
                en: "File",
				es: "Fichero",
				it: "File"
            },
            edit: {
                en: "Edit",
				es: "Edición",
				it: "Modifica"
            },
            view: {
                en: "View",
				es: "Ver",
				it: "Visualizza"
            },
            help: {
                en: "Help",
				es: "Ayuda",
				it: "Aiuto"
            },
            addNewWorkbench: {
                en: "Add New Workbench",
				es: "Nueva poyata",
				it: "Nuovo piano di lavoro"
            },
            renameWorkbench: {
                en: "Rename Workbench",
				es: "Renombrar poyata",
				it: "Rinomina piano di lavoro"
            },
            loadAssignment: {
                en: "Load an Assignment",
				es: "Cargar tareas",
				it: "Carica un compito"
            },
            presentationMode: {
                en: "Presentation Mode",
				es: "Modo de presentación",
				it: "Modalità presentazione"
            },
            zoomOut: {
                en: "Zoom Out",
                es: "Disminuir",
                it: "Diminuire"
            },
            zoomIn: {
                en: "Zoom In",
                es: "Agrandar",
                it: "Ingrandire"
            },
            resetZoom: {
                en: "Reset Zoom",
                es: "Reiniciar empinadura",
                it: "Azzerare ingrandimento"
            },
            aboutVlab: {
                en: "About VLab",
				es: "Acerca de VLab",
				it: "Su VLab"
            },
            videoWalkthrough: {
                en: "Video Walkthrough",
				es: "Tutorial",
				it: "Video Tutorial"
            },
            tips: {
                en: "Tips",
                es: "Consejos",
                it: "Consiglios"
            }
        },
        actions: {
            removeSolid: {
                en: "Remove Solid",
				es: "Descartar sólido",
				it: "Rimuovi Solido"
            },
            removeLiquid: {
                en: "Remove Liquid",
				es: "Descartar liquido",
				it: "Rimuovi Liquido"
            },
            duplicate: {
                en: "Duplicate",
				es: "Duplicar",
				it: "Duplica"
            },
            thermalProperties: {
                en: "Thermal properties...",
				es: "Propiedades térmicas...",
				it: "Proprietà termiche..."
            },
            rename: {
                en: "Rename",
				es: "Renombrar",
				it: "Rinomina"
            },
            remove: {
                en: "Remove",
				es: "Eliminar",
				it: "Elimina"
            },
            clearWorkbench: {
                en: "Clear Workbench",
				es: "Despejar poyata",
				it: "Pulisci piano di lavoro"
            },
            detailView: {
                en: "Detail View",
                es: "Vista detalle",
                it: "Vista in dettaglio"
            }
        },
        app: {
            stockroom: {
                en: "Stockroom",
				es: "Almacén",
				it: "Magazzino"
            },
            information: {
                en: "Information",
				es: "Información",
				it: "Informazioni"
            },
            workbench: {
                en: "Workbench",
				es: "Poyata",
				it: "Piano di lavoro"
            }
        },
        assignment: {
            authors: {
                en: "Author(s)",
				es: "Autor(es)",
				it: "Autori"
            }
        },
        assignmentModal: {
            selectAssignment: {
                en: "Select an Assignment",
				es: "Seleccione una tarea",
				it: "Seleziona un compito"
            }
        },
        instrumentPanel: {
            graph: {
                en: "Graph",
				es: "Grafico",
				it: "Grafico"
            },
            table: {
                en: "Table",
				es: "Tabla",
				it: "Tavolo"
            },
            dlAbsTable: {
                en: "Download Absorbance Table",
				es: "Descargar tabla de absorbancia",
				it: "Scarica tabella dell'assorbanza"
            },
            trackVessel: {
                en: "Track Vessel",
				es: "Rastrear matraz",
				it: "Traccia recipiente"
            },
            startTracking: {
                en: "Start Tracking",
				es: "Comenzar a rastrear",
				it: "Avvia tracciamento"
            },
            takeDataPt: {
                en: "Take Data Point",
				es: "Tomar punto de datos",
				it: "Prendi dati"
            },
            dlLog: {
                en: "Download Log",
				es: "Descargar datos",
				it: "Scarica Log"
            },
            showAbsorbance: {
                en: "Display Absorbance",
				es: "Mostrar absorbancia",
				it: "Mostra assorbanza"
            },
            everySecond: {
                en: "Every second",
				es: "Cada segundo",
				it: "Ogni secondo"
            },
            whenPoured: {
                en: "When something is poured to the vessel",
				es: "Cuando algo se añade al matraz",
				it: "Quando qualcosa viene versato nel recipiente"
            }
        },
        viewers: {
            assignment: {
                en: "Assignment",
				es: "Tarea",
				it: "Compito"
            },
            solutionProperties: {
                en: "Solution Properties",
				es: "Propiedades de la solución",
				it: "Proprietà della soluzione"
            },
            thermometer: {
                en: "Thermometer",
				es: "Termómetro",
				it: "Termometro"
            },
            pH: {
                en: "pH",
				es: "pH",
				it: "pH"
            },
            aqueous: {
                en: "Aqueous Species Viewer",
				es: "Visor de especies acuosos",
				it: "Visualizzatore di specie acquose"
            },
            solid: {
                en: "Solid Species Viewer",
				es: "Visor de especies sólidos",
				it: "Visualizzatore di specie solide"
            },
            gas: {
                en: "Gas Species Viewer",
                es: "Visor de especies gaseosas",
                it: "Visualizzatore di specie gassose"
            },
            spectrometer: {
                en: "Spectrometer",
				es: "Espectrómetro",
				it: "Spettrometro"
            },
            particleView: {
                en: "Particle Viewer",
				es: "Visor de partículas",
				it: "Visualizzatore di particelle"
            },
            vesselTrackingControl: {
                en: "Vessel Tracking",
				es: "Rastreador de matraces",
				it: "Tracciamento recipiente"
            }
        },
        units: {
            Molarity: {
                en: "Molarity",
				es: "Molaridad",
				it: "Molarità"
            },
            grams: {
                en: "grams",
				es: "gramos",
				it: "grammi"
            },
            moles: {
                en: "moles",
				es: "moles",
				it: "moli"
            },
            atm: {
                en: "Pressure (atm)",
                es: "Presión (atm)",
                it: "Pressione (atm)"
            }
        },
        solutionProperties: {
            name: {
                en: "Name",
				es: "Nombre",
				it: "Nome"
            },
            volume: {
                en: "Volume",
				es: "Volumen",
				it: "Volume"
            },
            temperature: {
                en: "Temperature",
				es: "Temperatura",
				it: "Temperatura"
            },
            speciesAq: {
                en: "Species (aq)",
				es: "Especies acuosos",
				it: "Specie (aq)"
            },
            speciesS: {
                en: "Species (s)",
				es: "Especies sólidos",
				it: "Specie (s)"
            },
            speciesG: {
                en: "Species (g)",
                es: "Especies gaseosas",
                it: "Specie (g)"
            },
            mass: {
                en: "Mass",
				es: "Masa",
				it: "Massa"
            }
        },
        spectrometer: {
            spectrometer: {
                en: "Spectrometer",
				es: "Espectrómetro",
				it: "Spettrometro"
            },
            wavelength: {
                en: "Wavelength",
				es: "Longitud de onda",
				it: "Lunghezza d'onda"
            },
            absorbance: {
                en: "Absorbance",
				es: "Absorbancia",
				it: "Assorbanza"
            },
            invalidWavelengthMessage: {
                en: "Please enter a valid wavelength.",
				es: "Por favor, introduzca una longitud válida.",
				it: "Inserire una lunghezza d'onda valida."
            },
            wavelengthRangeMessage: {
                en: "Please enter a wavelength between START and END nanometers.",
				es: "Por favor, introduzca una longitud entre START y END nanómetros.",
				it: "Inserire una lunghezza d'onda tra START e END ."
            }
        },
        particleView: {
            tooMany: {
                en: "Too many to show",
				es: "Demasiados para mostrar",
				it: "Troppi per visualizzare"
            },
            shown: {
                en: "Shown",
				es: "Mostrados",
				it: "Mostra"
            },
            tooFew: {
                en: "Too few to see",
				es: "Muy pocos para ver",
				it: "Troppo pochi per visualizzare"
            }
        },
        about: {
            permissions: {
                en: "This work is reproduced and distributed with the permission of the ChemCollective. No other use is permitted without the express prior written permission of the ChemCollective. For permission, contact",
				es: "Esta obra se reproduce y distribuye con el permiso del ChemCollective. Ningún otro uso se permite sin el permiso escrito anterior expreso del ChemCollective. Para permiso, contacte",
				it: "Questo lavoro è riprodotto e distribuito con il permesso di ChemCollective. Non è permesso alcun altro uso senza il permesso scritto esplicito di ChemCollective. Per il permesso, contattare,"
            },
            reportBug: {
                en: "Report a bug",
				es: "Reportar un error",
				it: "Riportare un bug"
            }
        },
        stockroom: {
            solutions: {
                en: "Solutions",
				es: "Soluciones",
				it: "Soluzioni"
            },
            glassware: {
                en: "Glassware",
				es: "Material vidrio",
				it: "Vetreria"
            },
            tools: {
                en: "Tools",
				es: "Instrumentos",
				it: "Strumenti"
            }
        },
        workbench: {
            precise: {
                en: "Precise",
				es: "Precisa",
				it: "Preciso"
            },
            sigFig: {
                en: "Sig Fig",
				es: "Cifras significativas",
				it: "Cif. Sign."
            },
            realistic: {
                en: "Realistic",
				es: "Realista",
				it: "Realistico"
            },
            withdraw: {
                en: "Withdraw",
				es: "Quitar",
				it: "Preleva"
            },
            pour: {
                en: "Pour",
				es: "Añadir",
				it: "Versa"
            },
            holdToWithdraw: {
                en: "Hold to Withdraw",
				es: "Sujetar para quitar",
				it: "Tieni premuto per prelevare"
            },
            holdToPour: {
                en: "Hold to Pour",
				es: "Sujetar para añadir",
				it: "Tieni premuto per versare"
            },
            insulated: {
                en: "Insulated from surroundings",
				es: "Aislado del entorno",
				it: "Isolato dall'ambiente"
            },
            renameTo: {
                en: "Rename to:",
				es: "Reetiquetar a:",
				it: "Rinomina:"
            },
            fromTo: {
                en: "From SOURCE to TARGET",
				es: "De SOURCE a TARGET",
				it: "Da SOURCE a TARGET"
            },
            notEnoughWarning: {
                en: "Source vessel does not have enough volume. <br> Your desired volume has not been completely transferred.",
				es: "Matraz no tiene volumen suficiente. <br> Su volumen deseado no ha transferido completemente.",
				it: "Il recipiente non contiene abbastanza liquido. <br> Il volume desiderato non è stato completamente trasferito."
            },
            notEnoughSolidWarning: {
                en: "Source vessel does not have enough solid. <br> Your desired mass has not been completely transferred.",
				es: "Matraz no tiene sólido suficiente. <br> Su masa deseada no ha transferido completemente.",
				it: "Il recipiente non contiene abbastanza solido. <br> La massa desiderata non è stata completamente trasferita."
            },
            overfillWarning: {
                en: "Target vessel will overflow. <br> Your desired volume has not been completely transferred.",
				es: "Matraz se va a sobrellenar. <br> Su volumen deseado no ha transferido completemente.",
				it: "Il recipiente è pieno. <br> Il volume desiderato non è stato completamete trasferito."
            },
            solidOverfillWarning: {
                en: "Target vessel will overflow. <br> Your desired mass has not been completely transferred.",
				es: "Matraz se va a sobrellenar. <br> Su masa deseada no ha transferido completemente.",
				it: "Il recipiente è pieno. <br> La massa desiderata non è stata completamente trasferita."
            },
            pipetteOverfillWarning: {
                en: "Pipette will overfill. <br> Your desired volume has not been completely transferred.",
				es: "Pipeta se va a sobrellenar. <br> Su volumen deseado no ha transferido completemente.",
				it: "La pipetta è piena. <br> Il volume desiderato non è stato completamente trasferito."
            },
            volumeTransferred: {
                en: "AMOUNT mL transferred.",
				es: "AMOUNT mL transferido.",
				it: "AMOUNT (mL) trasferiti"
            },
            massTransferred: {
                en: "AMOUNT g transferred.",
				es: "AMOUNT g transferido.",
				it: "AMOUNT (g) trasferiti"
            },
            invalidAmountWarning: {
                en: "Please enter a valid amount.",
				es: "Por favor, introduzca una cantidad válida.",
				it: "Introdurre una quantità valida."
            },
            invalidPipetteSigFigWarning: {
                en: "Invalid amount! <br> A pipette can only precisely transfer its maximum volume, in this case AMOUNT.00",
				es: "¡Cantidad inválida! <br> Una pipeta solo puede transferir precisamente su volumen máximo, en este caso AMOUNT.00",
				it: "Quantità non valida. <br> Una pipetta può trasferire precisamente solo il suo volume massimo. in questo caso AMOUNT.00,"
            },
            invalidSigFigWarning: {
                en: "Invalid amount! <br> Watch those significant digits! Perhaps you meant AMOUNT?",
				es: "¡Cantidad inválida! <br> ¡Vigile las cifras significativas! ¿Quizás quiere decir AMOUNT?",
				it: "Quantiatà non valida! <br> Controlla le cifre significative. Forse intendevi AMOUNT?"
            }
        },
        glassware: {
            Erlenmeyers: {
                en: "Erlenmeyers",
				es: "Erlenmeyers",
				it: "Beute"
            },
            Graduated_Cylinders: {
                en: "Graduated Cylinders",
				es: "Probetas",
				it: "Cilindri graduati"
            },
            Pipettes: {
                en: "Pipettes",
				es: "Pipetas",
				it: "Pipette tarate"
            },
            Beakers: {
                en: "Beakers",
				es: "Vasos de precipitados",
				it: "Beaker"
            },
            Volumetric_Flasks: {
                en: "Volumetric Flasks",
				es: "Matraces aforados",
				it: "Matracci tarati"
            },
            Other: {
                en: "Other",
				es: "Otros",
				it: "Altro"
            },
            "250_mL_Flask": {
                en: "250 mL Flask",
				es: "Matraz 250 mL",
				it: "Beuta 250 mL"
            },
            "500_mL_Flask": {
                en: "500 mL Flask",
				es: "Matraz 500 mL",
				it: "Beuta 500 mL"
            },
            "1000_mL_Flask": {
                en: "1000 mL Flask",
				es: "Matraz 1000 mL",
				it: "Beuta 1000 mL"
            },
            "10_mL_Graduated_Cylinder": {
                en: "10 mL Graduated Cylinder",
				es: "Probeta 10 mL",
				it: "Cilindro graduato 10 mL"
            },
            "25_mL_Graduated_Cylinder": {
                en: "25 mL Graduated Cylinder",
				es: "Probeta 25 mL",
				it: "Cilindro graduato 25 mL"
            },
            "50_mL_Graduated_Cylinder": {
                en: "50 mL Graduated Cylinder",
				es: "Probeta 50 mL",
				it: "Cilindro graduato 50 mL"
            },
            "100_mL_Graduated_Cylinder": {
                en: "100 mL Graduated Cylinder",
				es: "Probeta 100 mL",
				it: "Cilindro graduato 100 mL"
            },
            "5_mL_Pipette": {
                en: "5 mL Pipette",
				es: "Pipeta 5 mL",
				it: "Pipetta 5 mL"
            },
            "10_mL_Pipette": {
                en: "10 mL Pipette",
				es: "Pipeta 10 mL",
				it: "Pipetta 10 mL"
            },
            "25_mL_Pipette": {
                en: "25 mL Pipette",
				es: "Pipeta 25 mL",
				it: "Pipetta 25 mL"
            },
            "Disposable_Pipette": {
                en: "Disposable Pipette",
				es: "Pipeta desechable",
				it: "Pipetta monouso 25 mL"
            },
            "250_mL_Beaker": {
                en: "250 mL Beaker",
				es: "Vaso de precipitados 250 mL",
				it: "Beaker 250 mL"
            },
            "600_mL_Beaker": {
                en: "600 mL Beaker",
				es: "Vaso de precipitados 600 mL",
				it: "Beaker 600 mL"
            },
            "1000_mL_Beaker": {
                en: "1000 mL Beaker",
				es: "Vaso de precipitados 1000 mL",
				it: "Beaker 1000 mL"
            },
            "100_mL_Volumetric_Flask": {
                en: "100 mL Volumetric Flask",
				es: "Matraz aforado 100 mL",
				it: "Matraccio tarato 100 mL"
            },
            "250_mL_Volumetric_Flask": {
                en: "250 mL Volumetric Flask",
				es: "Matraz aforado 250 mL",
				it: "Matraccio tarato 250 mL"
            },
            "500_mL_Volumetric_Flask": {
                en: "500 mL Volumetric Flask",
				es: "Matraz aforado 500 mL",
				it: "Matraccio tarato 500 mL"
            },
            "1000_mL_Volumetric_Flask": {
                en: "1000 mL Volumetric Flask",
				es: "Matraz aforado 1000 mL",
				it: "Matraccio tarato 1000 mL"
            },
            "Foam_Cup": {
                en: "Foam Cup",
				es: "Frasco aislado",
				it: "Bicchiere termico"
            },
            "Weigh_Boat": {
                en: "Weigh Boat",
				es: "Cápsula",
				it: "Barchetta per pesata"
            },
            "50_mL_Burette": {
                en: "50 mL Burette",
				es: "Bureta 50 mL",
				it: "Buretta 50 mL"
            }
        },
        tools: {
            Bunsen_Burner: {
                en: "Bunsen Burner",
				es: "Mechero Bunsen",
				it: "Becco Bunsen"
            },
            Scale: {
                en: "Scale",
				es: "Balanza",
				it: "Bilancia"
            }
        },
        tips: {
            tip: {
                en: "Tip",
                es: "Consejo",
                it: "Consiglio"
            },
            tip1: {
                en: "Welcome to the new HTML5 version of the Virtual Lab! In this version, the Solution Information Panel is now located on the left and appears when a solution is selected.",
                es: "¡Bienvenido a la versión nueva HTML5 del Virtual Lab! En esta versión, la información de la solución se ubica a la izquierda y aparece cuando una solución se selecciona.",
                it: "Benvenuti nella nuova versione HTML5 di Virtual Lab! In questa versione, le informazioni soluzione si trova sulla sinistra e appare quando viene selezionata una soluzione."
            },
            tip2: {
                en: "The problem description is now located in the upper right. For a full demonstration of how to use the lab, please click the video link above.",
                es: "La descripción del problema ahora se ubica en la parte superior derecha. Para una demostración completa de usar el laboratorio, haz clic en el enlace del video.",
                it: "La descrizione del problema trova ora in alto a destra. Per una dimostrazione completa di utilizzare il laboratorio, clicca sul link del video."
            },
            nextTip: {
                en: "Next Tip",
                es: "Siguiente consejo",
                it: "Prossimo Consiglio"
            },
            previousTip: {
                en: "Previous Tip",
                es: "Consejo anterior",
                it: "Consiglio Precedente"
            },
            gotIt: {
                en: "Got it!",
                es: "¡Comprendo!",
                it: "Capisco"
            }
        },
        decimal: {
            en: ".",
            es: ",",
            it: ","
        }
    }
});